/*
  pnx-unit-price.js（Issue #8・PNX-ARCH判定 2026-09-02）
  卸価格（Samita等が書き換えた価格）から「参考単価」を求めるための、アプリ非依存の純粋関数。
  DOMもアプリも触らない。呼び出し側（pnx-complementary-purchase.js）が
  「価格文字列・入数・通常価格」を渡し、結果の state に従って表示を決める。

  ルール（ARCH Blocking 3・4・9）:
  - 価格文字列の数値トークンが「ちょうど1個」のときだけ採用する（「最後の数字を取る」は使わない）
  - 卸価格は 0 より大きく、通常価格より小さいときだけ有効
  - 入数は Liquid 由来の整数（1以上）。商品名・variant名から解析しない
  - 整形は snippets/pnx-unit-price-calc（小数2桁round・割り切れる場合は整数）と同じ
*/
(function (root) {
  'use strict';

  /* "11,385円" → 11385。トークンがちょうど1個でなければ null */
  function parseSinglePrice(text) {
    if (typeof text !== 'string') return null;
    var tokens = text.match(/[0-9][0-9,]*(?:\.[0-9]+)?/g);
    if (!tokens || tokens.length !== 1) return null;
    var value = parseFloat(tokens[0].replace(/,/g, ''));
    if (!isFinite(value) || value <= 0) return null;
    return value;
  }

  /* 整数入数（1以上）だけ通す */
  function parseIrisu(value) {
    var str = String(value).trim();
    if (!/^[0-9]+$/.test(str)) return null;
    var n = parseInt(str, 10);
    if (!isFinite(n) || n < 1) return null;
    return n;
  }

  /* 通常価格（円）。0以下・非数は null */
  function parseRetailYen(value) {
    var n = typeof value === 'number' ? value : parseFloat(String(value));
    if (!isFinite(n) || n <= 0) return null;
    return n;
  }

  /* price ÷ irisu を小数2桁で丸め、pnx-unit-price-calc と同じ表記にする */
  function computeUnitPrice(priceYen, irisu) {
    var unit = Math.round((priceYen / irisu) * 100) / 100;
    if (!isFinite(unit) || unit <= 0) return null;
    return unit;
  }

  function formatUnitPrice(unit) {
    if (unit === null || unit === undefined) return '';
    if (Math.floor(unit) === unit) return String(unit);
    return String(Number(unit.toFixed(2)));
  }

  /*
    卸価格文字列から参考単価を評価する。
    戻り値: { state: 'valid-custom' | 'invalid', reason, priceYen, unit, text }
  */
  function evaluateWholesaleUnitPrice(input) {
    var irisu = parseIrisu(input && input.irisu);
    var retail = parseRetailYen(input && input.retailYen);
    var price = parseSinglePrice(input && input.priceText);
    if (irisu === null) return { state: 'invalid', reason: 'irisu' };
    if (retail === null) return { state: 'invalid', reason: 'retail' };
    if (price === null) return { state: 'invalid', reason: 'price-token' };
    if (price >= retail) return { state: 'invalid', reason: 'not-lower-than-retail' };
    var unit = computeUnitPrice(price, irisu);
    if (unit === null) return { state: 'invalid', reason: 'unit' };
    return { state: 'valid-custom', priceYen: price, unit: unit, text: formatUnitPrice(unit) };
  }

  var api = {
    parseSinglePrice: parseSinglePrice,
    parseIrisu: parseIrisu,
    parseRetailYen: parseRetailYen,
    computeUnitPrice: computeUnitPrice,
    formatUnitPrice: formatUnitPrice,
    evaluateWholesaleUnitPrice: evaluateWholesaleUnitPrice,
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }
  root.PnxUnitPrice = api;
})(typeof window !== 'undefined' ? window : globalThis);
